/* eslint-disable curly */
import React, { Component, useEffect, useRef, useState } from "react";
import {
  View,
  Text,
  TextInput,
  TouchableOpacity,
  Keyboard,
  Platform,
  ScrollView,
  KeyboardAvoidingView,
  ImageBackground,
} from "react-native";
import { StackActions, NavigationActions } from "react-navigation";
import { EventRegister } from "react-native-event-listeners";
import Icon from "react-native-vector-icons/FontAwesome";

import styles from "./styles";
import ButtonConfirm from "../../components/ButtonConfirm";
import Loading from "../../components/Loading";
import {
  enviarCodigoSMS,
  validarCodigoSMS,
} from "../../services/aluno-service";
import { getAluno } from "../../services/auth-service";
import { alert } from "../../utils/alerts";

const VerificarCodigoSMS = ({ route, navigation }) => {
  const [codigo, setCodigo] = useState("");
  const [loading, setLoading] = useState(false);
  const [confirmDisabled, setConfirmDisabled] = useState(true);
  const [cronometro, setCronometro] = useState(0);
  const [getTime, setGetTime] = useState(null);
  const campoCodigo = useRef(null);
  const buttonReenviarSMS = useRef(null);

  useEffect(() => {
    setCronometro(59);
    startClock();

    return () => {
      clearInterval(getTime);
    };
  }, []);

  const startClock = () => {
    const time = setInterval(() => {
      setCronometro((c) => {
        return c > 0 ? c - 1 : 0;
      });
    }, 1000);
    setGetTime(time);
  };

  useEffect(() => {
    if (cronometro == 0) {
      clearInterval(getTime);
    }
  }, [cronometro]);

  const handlerCodigo = async (e) => {
    setCodigo(e);
    if (!e.trim().match(/^[0-9]{6}$/i)) {
      setConfirmDisabled(true);
    } else {
      setConfirmDisabled(false);
    }
  };

  const handlerReenviarSMS = async (e) => {
    const { telefoneId, whatsapp } = navigation.state.params;

    const response = await enviarCodigoSMS(telefoneId, whatsapp);

    if (!response.ok) {
      let { erro } = await response.json();
      setLoading(false);
      return alert("Ops...", erro);
    }

    setCronometro(119);
    startClock();
  };

  const enviar = async () => {
    setLoading(true);

    const { telefoneId } = navigation.state.params;

    try {
      const response = await validarCodigoSMS({
        telefone_id: telefoneId,
        codigo_sms: codigo,
      });

      if (!response.ok) {
        let { erro } = await response.json();
        setLoading(false);
        return alert("Ops...", erro);
      }

      Keyboard.dismiss();
      EventRegister.emit("reload", "");

      const fromSemTelefone = navigation.state.params;

      console.log(fromSemTelefone);

      if (fromSemTelefone) {
        return navigation.navigate("DefinirSenha");

        // const navigateAction = StackActions.reset({
        //   index: 0,
        //   actions: [NavigationActions.navigate({ routeName: "RegistrarSenha" })],
        // });

        // return navigation.dispatch(navigateAction);
      }

      navigation.pop(3);
    } catch (erro) {
      setLoading(false);
      console.log(erro);
      alert(
        "Ops...",
        "Houve um problema ao consultar, verifique o codigo e tente novamente"
      );
    }
  };

  return (
    <>
      {loading && <Loading />}
      <KeyboardAvoidingView
        style={styles.container}
        behavior={Platform.select({
          ios: "padding",
          android: "null",
        })}
        keyboardVerticalOffset={Platform.select({ ios: 64, android: 0 })}
      >
        <ImageBackground
          source={require("../../../resources/imgs/bg.jpg")}
          style={styles.container}
          imageStyle={styles.imageContainer}
        >
          <View style={[styles.containerForm]}>
            <ScrollView style={{ flex: 1, width: "100%" }}>
              <Text style={styles.textHeader1}>
                Verifique seus SMS, enviamos um código para você.
              </Text>
              <TextInput
                value={codigo}
                style={[styles.input, { letterSpacing: 10 }]}
                editable={!loading}
                placeholder="999999"
                maxLength={6}
                keyboardType="default"
                autoCapitalize="none"
                textContentType="oneTimeCode"
                autoFocus={true}
                placeholderTextColor="#CCC"
                onChangeText={handlerCodigo}
                onSubmitEditing={enviar}
              />
              <Text style={styles.textHeader2}>Não recebeu?</Text>
              <TouchableOpacity
                disabled={cronometro !== 0}
                ref={buttonReenviarSMS}
                onPress={handlerReenviarSMS}
              >
                <Text
                  style={[
                    styles.link,
                    {
                      marginTop: 5,
                      alignSelf: "center",
                      color: cronometro === 0 ? "#FFF" : "#BBB",
                    },
                  ]}
                >
                  Enviar novamente{cronometro !== 0 && ` em ${cronometro}s`}
                </Text>
              </TouchableOpacity>
            </ScrollView>
            <ButtonConfirm
              text={loading ? "Enviando..." : "Enviar"}
              disabled={confirmDisabled}
              onPress={enviar}
              msgDisabled="Por favor, preencha os campos com um telefone válido"
            />
          </View>
        </ImageBackground>
      </KeyboardAvoidingView>
    </>
  );
};

VerificarCodigoSMS.navigationOptions = ({ navigation }) => {
  return {
    headerStyle: {
      backgroundColor: "#0F0F0F",
    },
    headerTitleStyle: {
      color: "#FFF",
    },
    headerLeft: () => (
      <TouchableOpacity
        onPress={() => {
          const navigateAction = StackActions.pop(3);
          navigation.dispatch(navigateAction);
        }}
      >
        <Icon
          style={styles.iconToggle}
          name="arrow-left"
          size={20}
          color="#F1F1F1"
        />
      </TouchableOpacity>
    ),
  };
};

export default VerificarCodigoSMS;
